type UploadStatusPanelProps = {
  error?: string | null;
  isUploading: boolean;
  progress: number;
  progressTone?: "blue" | "purple";
};

const progressClasses = {
  blue: "bg-blue-600",
  purple: "bg-purple-600",
} as const;

export function UploadStatusPanel({
  error,
  isUploading,
  progress,
  progressTone = "blue",
}: UploadStatusPanelProps) {
  return (
    <>
      {isUploading && (
        <div className="mb-6">
          <div className="flex justify-between text-sm text-gray-600 dark:text-[#B5A9AA] mb-2">
            <span>Uploading...</span>
            <span>{progress}%</span>
          </div>
          <div className="w-full bg-gray-200 dark:bg-[#5B5353] rounded-full h-2">
            <div
              className={`${progressClasses[progressTone]} h-2 rounded-full transition-all duration-300`}
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}

      {error && (
        <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-[#5B5353] rounded-lg">
          <div className="flex">
            <svg
              className="h-5 w-5 text-red-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
            <p className="ml-3 text-sm text-red-700 dark:text-[#FFF1F3]">
              {error}
            </p>
          </div>
        </div>
      )}
    </>
  );
}
